import { fromJS, Map } from 'immutable';
import {
  DOMAINS,
  START_DRAG,
  STOP_DRAG,
  DOMAIN_PROPERTY_DRAG_STATE,
  DOMAIN_PROPERTY_DRAG_TYPE,
  DOMAIN_PROPERTY_DRAG_DATA,
} from './constants';
import DragState from './constants/DragState';

const initialState = fromJS({
  [DOMAINS]: {}, // Each domain can only have one thing dragged at a time
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case START_DRAG: {
      const { domainName, dragType, dragData } = action;

      return state.updateIn([DOMAINS, domainName], (domain = Map()) => {
        if (domain.get(DOMAIN_PROPERTY_DRAG_STATE) === DragState.DRAGGING) {
          // If already dragging, do nothing
          return domain;
        }

        return domain
          .set(DOMAIN_PROPERTY_DRAG_STATE, DragState.DRAGGING)
          .set(DOMAIN_PROPERTY_DRAG_TYPE, fromJS(dragType))
          .set(DOMAIN_PROPERTY_DRAG_DATA, fromJS(dragData));
      });
    }
    case STOP_DRAG: {
      const { domainName } = action;

      return state.updateIn([DOMAINS, domainName], (domain = Map()) => (
        domain
          .set(DOMAIN_PROPERTY_DRAG_STATE, DragState.NOT_DRAGGING)
          .set(DOMAIN_PROPERTY_DRAG_TYPE, null)
          .set(DOMAIN_PROPERTY_DRAG_DATA, null)
      ));
    }
    default:
      return state;
  }
};

export default reducer;
